import { Navigate, Route, Routes } from 'react-router-dom'
import BillingDashboard from './BillingDashboard'
import CustomerDetailPage from './CustomerDetail'
import TrialMonitoring from './TrialMonitoring'
import InfluencersPage from './InfluencersPage'
import InfluencerDetailPage from './InfluencerDetail'
import InfluencersLayout from './InfluencersContext'
import { MobileOffersPage } from './mobile-offers/MobileOffersPage'

export default function BillingRoutes() {
    return (
        <Routes>
            <Route index element={<BillingDashboard />} />
            <Route path="trials" element={<TrialMonitoring />} />
            <Route path="mobile-offers/*" element={<MobileOffersPage />} />
            <Route path="influencers" element={<InfluencersLayout />}>
                <Route index element={<InfluencersPage />} />
                <Route path=":id" element={<InfluencerDetailPage />} />
            </Route>
            <Route path=":appId" element={<CustomerDetailPage />} />
            <Route path="*" element={<Navigate to="." replace />} />
        </Routes>
    )
}
